export default "__VITE_ASSET__BDzMXm02__"